import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import SellerOnlyRouteMixin from 'sh-www/mixins/seller-only-route-mixin';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

/** @module */
class PostingApplyRoute extends Route.extend(SellerOnlyRouteMixin) {
  /** @type {Ember.Service} */
  @service('state-managers/routes/posting') stateManager;
  @service router;

  /** @inheritDoc */
  model() {
    const { assignId } = this.paramsFor('posting');
    return this.stateManager.loadAssignmentForId(assignId);
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);

    this.controllerFor('application').setProperties({
      isShowSimpleHeader: true,
      simpleHeaderText: 'Apply to posting',
      simpleHeaderRightText: 'Cancel',
      simpleHeaderRightAction: () => {
        this.router.transitionTo('posting.index', this.controller.model.idWithSlug);
      },
    });

    trackPageViewFromTransition(this, transition, '/posting/:id/apply/');
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);

    this.controllerFor('application').setProperties({
      isShowSimpleHeader: false,
      simpleHeaderText: '',
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null,
    });
  }
}

export default PostingApplyRoute;
